"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _fsm = require("@xstate/fsm");

var _validation = _interopRequireDefault(require("../messages/validation"));

var _icon = _interopRequireDefault(require("../icon"));

var _state = _interopRequireDefault(require("./state"));

var _uploadingButton = _interopRequireDefault(require("./uploading-button"));

var _constants = require("./constants");

var _style = _interopRequireDefault(require("./style.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_style["default"]);

var _ref = /*#__PURE__*/_jsx(_icon["default"], {
  name: "checkmark-mini"
});

var FileUploader = /*#__PURE__*/function (_Component) {
  _inherits(FileUploader, _Component);

  var _super = _createSuper(FileUploader);

  function FileUploader(_props) {
    var _this;

    _classCallCheck(this, FileUploader);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "service", void 0);

    _defineProperty(_assertThisInitialized(_this), "getContextByStatus", function (status) {
      var _contextMap;

      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props;
      var content = props.content;
      var contextMap = (_contextMap = {}, _defineProperty(_contextMap, _constants.STATUS_DEFAULT, _constants.INITIAL_CONTEXT), _defineProperty(_contextMap, _constants.STATUS_UPLOADING, _objectSpread(_objectSpread({}, _constants.INITIAL_CONTEXT), {}, {
        description: 'Uploading...',
        extra: null
      })), _defineProperty(_contextMap, _constants.STATUS_SUCCESS, _objectSpread(_objectSpread({}, _constants.INITIAL_CONTEXT), {}, {
        extra: null,
        renderExtra: function renderExtra() {
          return /*#__PURE__*/_jsx("div", {
            className: cx('xsui-file-uploader__icon-circle')
          }, void 0, _ref);
        }
      })), _defineProperty(_contextMap, _constants.STATUS_ERROR, _constants.INITIAL_CONTEXT), _defineProperty(_contextMap, _constants.STATUS_DISABLED, _objectSpread(_objectSpread({}, _constants.INITIAL_CONTEXT), {}, {
        extra: null
      })), _contextMap);
      var baseContext = contextMap[status] || _constants.INITIAL_CONTEXT;
      var customContext = content[status] || {};
      return _objectSpread(_objectSpread({}, baseContext), customContext);
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (event) {
      var _this$props = _this.props,
          input = _this$props.input,
          onUpload = _this$props.onUpload,
          _this$props$meta = _this$props.meta,
          meta = _this$props$meta === void 0 ? {
        error: null
      } : _this$props$meta;

      var currentEvent = _objectSpread({}, event);

      _this.service.send(_objectSpread({
        type: 'UPLOAD'
      }, _this.getContextByStatus(_constants.STATUS_UPLOADING)));

      input.onChange(currentEvent.target.value);

      if (onUpload) {
        onUpload(event).then(function () {
          _this.service.send(_objectSpread({
            type: 'RESOLVE'
          }, _this.getContextByStatus(_constants.STATUS_SUCCESS)));

          setTimeout(function () {
            _this.service.send(_objectSpread({
              type: 'RESET'
            }, _this.getContextByStatus(_constants.STATUS_DEFAULT)));
          }, 2000);
        })["catch"](function (error) {
          var errorMessage = typeof error === 'string' ? error : '';

          _this.service.send(_objectSpread(_objectSpread({
            type: 'REJECT'
          }, _this.getContextByStatus(_constants.STATUS_ERROR)), {}, {
            error: errorMessage || meta.error
          }));
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderExtra", function () {
      var _this$props2 = _this.props,
          input = _this$props2.input,
          accept = _this$props2.accept;
      var current = _this.state.current;

      if (input.readOnly || input.disabled) {
        return;
      }

      if (current.context.renderExtra) {
        return current.context.renderExtra();
      }

      return /*#__PURE__*/_react["default"].createElement(_uploadingButton["default"], _extends({}, current.context.extra, {
        input: _objectSpread(_objectSpread({}, input), {}, {
          accept: accept || '*',
          onChange: _this.onChange
        })
      }));
    });

    var defaultContext = _props.content ? _this.getContextByStatus(_constants.STATUS_DEFAULT) : {};
    var fileUploaderMachine = (0, _state["default"])(defaultContext);
    _this.service = (0, _fsm.interpret)(fileUploaderMachine);
    _this.state = {
      current: fileUploaderMachine.initialState
    };
    return _this;
  }

  _createClass(FileUploader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props3 = this.props,
          input = _this$props3.input,
          _this$props3$meta = _this$props3.meta,
          meta = _this$props3$meta === void 0 ? {
        error: null,
        touched: false
      } : _this$props3$meta;
      this.service.subscribe(function (current) {
        return _this2.setState({
          current: current
        });
      });
      this.service.start();

      if (input && (input.disabled || input.readOnly)) {
        this.service.send(_objectSpread({
          type: 'DISABLE'
        }, this.getContextByStatus(_constants.STATUS_DISABLED)));
      }

      if (meta.error && meta.touched) {
        this.service.send(_objectSpread(_objectSpread({
          type: 'REJECT'
        }, this.getContextByStatus(_constants.STATUS_ERROR)), {}, {
          error: meta.error
        }));
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var current = this.state.current;
      var _this$props$meta2 = this.props.meta,
          meta = _this$props$meta2 === void 0 ? {
        error: null,
        dirty: false,
        submitFailed: false
      } : _this$props$meta2;
      var failedEmptyField = meta.error && prevProps.meta.error !== meta.error && !meta.dirty && meta.submitFailed;

      if (current.matches('disabled')) {
        var currentContext = this.getContextByStatus(_constants.STATUS_DISABLED);
        var prevContext = this.getContextByStatus(_constants.STATUS_DISABLED, prevProps);

        if (JSON.stringify(currentContext) !== JSON.stringify(prevContext)) {
          this.service.send(_objectSpread({
            type: 'UPDATE'
          }, currentContext));
        }
      }

      if (failedEmptyField) {
        this.service.send(_objectSpread(_objectSpread({
          type: 'REJECT'
        }, this.getContextByStatus(_constants.STATUS_ERROR)), {}, {
          error: meta.error
        }));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.service.stop();
    }
  }, {
    key: "render",
    value: function render() {
      var current = this.state.current;
      var dataId = this.props.dataId;
      var areaClassNames = {
        'xsui-file-uploader__area': true,
        'xsui-file-uploader__area--default': current.matches('default') || current.matches('error') || current.matches('disabled')
      };
      var barClassNames = {
        'xsui-file-uploader__progress-bar': true,
        'xsui-file-uploader__progress-bar--default': current.matches('default') || current.matches('error') || current.matches('disabled'),
        'xsui-file-uploader__progress-bar--uploading': current.matches('uploading'),
        'xsui-file-uploader__progress-bar--success': current.matches('success')
      };
      return /*#__PURE__*/_jsx("div", {
        className: cx('xsui-file-uploader'),
        "data-id": dataId
      }, void 0, /*#__PURE__*/_jsx("div", {
        className: cx(areaClassNames)
      }, void 0, /*#__PURE__*/_jsx("div", {
        className: cx(barClassNames)
      }), /*#__PURE__*/_jsx("div", {
        className: cx('xsui-file-uploader__info')
      }, void 0, /*#__PURE__*/_jsx("div", {
        className: cx('xsui-file-uploader__text', 'xsui-file-uploader__text--main')
      }, void 0, current.context.title), /*#__PURE__*/_jsx("div", {
        className: cx('xsui-file-uploader__text', 'xsui-file-uploader__text--sub')
      }, void 0, current.context.description)), /*#__PURE__*/_jsx("div", {
        className: cx('xsui-file-uploader__extra-wrapper')
      }, void 0, this.renderExtra())), current.matches('error') && /*#__PURE__*/_jsx(_validation["default"], {}, void 0, current.context.error));
    }
  }]);

  return FileUploader;
}(_react.Component);

var _default = FileUploader;
exports["default"] = _default;